/* sdx-product-slider — arrow navigation + scroll-snap bridging */
(function () {
  'use strict';

  function init(root) {
    const track = root.querySelector('[data-sdx-ps-track]');
    if (!track) return;
    const prev = root.querySelector('[data-sdx-ps-prev]');
    const next = root.querySelector('[data-sdx-ps-next]');

    const step = () => Math.max(200, track.clientWidth * 0.8);

    function updateButtons() {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 2);
      if (next) next.toggleAttribute('disabled', track.scrollLeft >= max);
    }

    if (prev) prev.addEventListener('click', () => {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', () => {
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(updateButtons);
      } else {
        updateButtons();
      }
    }, { passive: true });

    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  document.querySelectorAll('[data-sdx-ps]').forEach(init);

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-sdx-ps]').forEach(init);
  });
})();
